import { render } from "./ReferralsList.vue?vue&type=template&id=29026c7a"
import script from "./ReferralsList.vue?vue&type=script&lang=js"
export * from "./ReferralsList.vue?vue&type=script&lang=js"

import "./ReferralsList.vue?vue&type=style&index=0&id=29026c7a&lang=scss"

import exportComponent from "/Users/a/Documents/work/new/prnew/lk-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__